import { atom, RecoilState } from 'recoil';

/**
 * Currently selected graph ID. Shared across the Graph panel and the graph
 * tab selector rendered in the panel's drag-tab.
 *
 * Value ``'none'`` means nothing is selected. Any other string is an entry
 * key from the Recoil ``graphState`` dictionary.
 */
export const graphSelectionState: RecoilState<string> = atom<string>({
  key: 'GraphSelection',
  default: 'none'
});

/**
 * Mirror of the backend ``Operation.active_target_id``. Hydrated via the
 * ``active_target_changed`` socket event emitted by ``applit.display_coa_graph``
 * and ``on_chat_resume``. ``null`` means no target has been captured yet.
 */
export const activeTargetIdState: RecoilState<string | null> = atom<string | null>({
  key: 'ActiveTargetId',
  default: null
});

/**
 * Index of the timeline snapshot currently displayed in the Graph panel, or
 * ``null`` for the live (latest) graph. Lifted out of the Graph component's
 * local state so the graph tab-bar controls (e.g. the STIX download button)
 * can rebuild the exact STIX bundle the operator is looking at — including a
 * scrubbed-back point in the ``GraphTimeline``.
 */
export const selectedSnapshotIndexState: RecoilState<number | null> = atom<number | null>({
  key: 'SelectedSnapshotIndex',
  default: null
});
